module.exports = __webpack_public_path__ + "static/media/acapulcoimg.b765947d.jpg";